





































































































































































































































import { DataParse } from "@wj/common";
import { Vue, Component } from "vue-property-decorator";
import {
  searchReq,
  addFormData,
  editFormData,
  addJobFormData,
  editJobFormData,
} from "@/common/class/scheduleManagement/index";
import {
  getByPage,
  getJobList,
  scheduleInsert,
  scheduleDelete,
  schedulePublish,
  getScheduleJobList,
  jobListInsert,
  scheduleEdit,
  jobEdit,
  getJobDetail,
  jobDelete,
  scheduleFinish,
} from "@/api/scheduleManagement/index";
import myLoading from "@/components/global/my-loading/index.vue";
import filters from "@/common/filter/config/filter";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { addQuillTitle } from "../quill-title";
import QRCode from "qrcodejs2";

interface valdata {
  quill: any;
  html: any;
  text: any;
}

@Component({
  components: {
    myLoading,
    quillEditor,
  },
})
export default class empowermentQueryComponent extends Vue {
  isRequest = false;
  req = new searchReq();
  addProReq = new addFormData();
  addJobFormData = new addJobFormData();
  editJobFormData = new editJobFormData();
  editProReq = new addJobFormData();
  tableloading = false;
  tableData = new DataParse();
  Height = 250;
  addDialogVisible = false;
  editDialogVisible = false;
  adddialogloading = false;
  editdialogloading = false;
  addJobDialogloading = false;
  addJobDialogVisible = false;
  editJobDialogloading = false;
  editJobDialogVisible = false;
  qrcodeDialog = false;
  divJobLoading = false;
  //当前选中行程id
  currentScheduleId = "";
  //当前选中岗位id
  currentJobId = "";
  editFormData = new editFormData();
  addFormData = new addFormData();
  jobNeedShow = false;
  editcheckAll = false;
  cityOptions: Array<any> = [];
  cityOptionsList: Array<any> = [];
  addCheckedCities: Array<any> = [];
  editCheckedCities: Array<any> = [];
  addcheckAll = false;
  editIsIndeterminate = true;
  addIsIndeterminate = true;
  clickNo = null;
  jobArr: Array<any> = [];
  validatePass = (rule: any, value: any, callback: any) => {
    if (value === "" || value === null) {
      callback(new Error("请选择宣讲时间"));
    } else {
      callback();
    }
  };
  validateZS = (rule: any, value: any, callback: any) => {
    let CEN = new RegExp(/^[1-9]\d*$/);
    if (!CEN.test(value)) {
      return callback(new Error("由正整数组成"));
    } else {
      callback();
    }
  };

  rules = {
    speechTime: [{ validator: this.validatePass, trigger: "change" }],
    university: [
      { required: true, message: "请填写宣讲学校", trigger: "change" },
      {
        min: 1,
        max: 100,
        message: "长度在 1 到 100 个字符",
        trigger: "change",
      },
    ],
    address: [
      { required: true, message: "请填写学校地址", trigger: "change" },
      {
        min: 1,
        max: 100,
        message: "长度在 1 到 100 个字符",
        trigger: "change",
      },
    ],
    expectationNumber: [
      { required: true, validator: this.validateZS, trigger: "change" },
    ],
  };
  rules2 = {
    number: [
      {
        required: true,
        validator: this.validateZS,
        message: "请填写需求数量",
        trigger: "blur",
      },
    ],
    workPlace: [
      { required: true, message: "请填写工作地点", trigger: "blur" },
      {
        min: 1,
        max: 100,
        message: "长度在 1 到 100 个字符",
        trigger: "blur",
      },
    ],
    education: [
      { required: true, message: "请填写学历要求", trigger: "blur" },
      {
        min: 1,
        max: 100,
        message: "长度在 1 到 100 个字符",
        trigger: "blur",
      },
    ],
    jobName: [
      { required: true, message: "请填写岗位名称", trigger: "blur" },
      {
        min: 1,
        max: 100,
        message: "长度在 1 到 100 个字符",
        trigger: "blur",
      },
    ],

    jobRequirements: [
      { required: true, message: "请填写岗位要求", trigger: "blur" },
      {
        trigger: "blur",
      },
    ],
    jobDescription: [
      { required: true, message: "请填写工作内容", trigger: "blur" },
      {
        trigger: "blur",
      },
    ],
  };

  selectedId = "";
  // 富文本编辑器默认内容
  content = "";
  //富文本编辑器配置
  editorOption = {
    // Some Quill options...
    // modules: {
    //   clipboard: {
    //     matchers: [[Node.ELEMENT_NODE, this.handleCustomMatcher]],
    //   },
    //   toolbar: [["bold", "italic", "underline", "strike"], ["blockquote", "code-block"], [{ header: 1 }, { header: 2 }], [{ list: "ordered" }, { list: "bullet" }], [{ script: "sub" }, { script: "super" }], [{ indent: "-1" }, { indent: "+1" }], [{ direction: "rtl" }], [{ size: ["small", false, "large", "huge"] }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ color: [] }, { background: [] }], [{ font: [] }], [{ align: [] }], ["clean"], ["link", "image", "video"]],
    // },
  };

  created() {
    /*  this.cities = this.cityOptions */
    this.getList();
    this.JobList();
  }

  mounted() {
    this.getHeight();
    window.addEventListener("resize", this.getHeight, false);
  }

  /*-------------------------------------- 富文本方法----------------------------------------------------- */
  //失去焦点事件
  onEditorBlur(quill: any) {
    console.log("editor blur!", quill);
  }
  //获得焦点事件
  onEditorFocus(quill: any) {
    console.log("editor focus!", quill);
  }
  // 准备富文本编辑器
  onEditorReady(quill: any) {
    console.log("editor ready!", quill);
  }
  //内容改变事件
  onEditorChange(valdata: any) {
    console.log("editor change!", valdata.quill, valdata.html, valdata.text);
    this.content = valdata.html;
    console.log(this.content);
  }

  // image2Base64(img: any) {
  //   var canvas = document.createElement("canvas");
  //   canvas.width = img.width;
  //   canvas.height = img.height;
  //   var ctx = canvas.getContext("2d");
  //   (ctx as any).drawImage(img, 0, 0, img.width, img.height);
  //   var dataURL = canvas.toDataURL("image/jpg");
  //   return dataURL;
  // }

  handleCustomMatcher(node: any, Delta: any) {
    let ops: any = [];
    Delta.ops.forEach((op: any) => {
      // if (op.insert && op.alt === "string") {
      ops.push({ insert: op.insert });
      // if(!op.attributes.height) {
      //   ops.push({ insert: op.insert });
      //   return
      // }
      // var img = new Image();
      // img.height = op.attributes.height;
      // img.width = op.attributes.width;
      // img.src = op.insert.image;
      // let that = this;
      // img.onload = function () {
      //   let base64 = that.image2Base64(img);
      //   console.log('ssssssqazwsx',base64);
      //   alert(base64);
      // };
      // }
    });
    Delta.ops = ops;
    return Delta;
  }
  /*------------------------------------------------------------------------------------------- */

  getHeight() {
    //获取浏览器高度并计算得到表格所用高度。
    this.$nextTick(() => {
      this.Height = document.documentElement.clientHeight - 240;
    });
  }
  handleAddCheckAllChange(val: any) {
    this.addCheckedCities = val ? this.cityOptions : [];
    this.addIsIndeterminate = false;
  }
  handleAddCheckedCitiesChange(value: any) {
    let checkedCount = value.length;
    this.addcheckAll = checkedCount === this.cityOptions.length;
    this.addIsIndeterminate =
      checkedCount > 0 && checkedCount < this.cityOptions.length;
  }
  handleEditCheckAllChange(val: any) {
    console.log("val");
    console.log(val);
    this.editCheckedCities = val ? this.cityOptions : [];
    this.editIsIndeterminate = false;
  }
  handleEditCheckedCitiesChange(value: any) {
    console.log("value");
    console.log(value);
    let checkedCount = value.length;
    this.editcheckAll = checkedCount === this.cityOptions.length;
    this.editIsIndeterminate =
      checkedCount > 0 && checkedCount < this.cityOptions.length;
  }
  // 查询
  onSubmit() {
    this.req.pageNo = 1;
    this.getList();
  }

  // 重置
  reSubmit() {
    this.req = new searchReq();
    this.getList();
  }

  // 获取列表
  getList() {
    this.tableloading = true;
    getByPage(this.req)
      .then((res) => {
        const { success, data, messgae } = res;
        if (success) {
          this.tableData.listItem = data.rows;
          this.tableData.total = data.total;
          this.tableData.getNo(this.req.pageNo, this.req.pageSize);
        }
      })
      .finally(() => {
        this.tableloading = false;
        if (this.tableData.listItem.length == 0 && this.tableData.total > 0) {
          this.req.pageNo--;
          this.getList();
        }
      });
  }
  //  表格选择
  handleSelectionChange(data: any) {
    let ids: any = [];
    data.forEach((item: any) => {
      ids.push(item.id);
    });
    this.selectedId = ids.join(",");
  }
  // 全选
  selectAll(data: any) {
    let ids: any = [];
    data.forEach((item: any) => {
      ids.push(item.id);
    });
    this.selectedId = ids.join(",");
  }

  // 行程发布下架
  itineraryPushDown(id: any, state: any) {
    this.isRequest = true;
    let param = { itIds: id, state: state };
    schedulePublish(param)
      .then((res) => {
        const { success, message, data } = res;
        if (success) {
          this.$message({
            type: "success",
            message: message,
          });
          this.getList();
        }
      })
      .finally(() => {
        this.isRequest = false;
      });
  }

  // 单个行程发布
  publish(data: any) {
    // state 1为发布，2为下架
    // if (data.state == 1) {
    //   this.$message({
    //     type: "warning",
    //     message: "已发布的行程不能重复发布！",
    //   });
    //   return
    // }
    this.$confirm("是否确定发布?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        this.itineraryPushDown(data.id, 1);
      })
      .catch(() => {});
  }
  // 批量发布
  batchPublish() {
    if (this.selectedId) {
      this.$confirm("是否确定发布?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.itineraryPushDown(this.selectedId, 1);
        })
        .catch(() => {});
    } else {
      this.$message({
        type: "warning",
        message: "请先选择数据！",
      });
    }
  }
  // 单个行程下架
  downItinerary(data: any) {
    this.$confirm("是否确定下架?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        this.itineraryPushDown(data.id, 2);
      })
      .catch(() => {});
  }
  // 批量下架
  batchDownItinerary() {
    if (this.selectedId) {
      this.$confirm("是否确定下架?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.itineraryPushDown(this.selectedId, 2);
        })
        .catch(() => {});
    } else {
      this.$message({
        type: "warning",
        message: "请先选择数据！",
      });
    }
  }
  //  二维码生成
  getQrCode(data: any) {
    this.qrcodeDialog = true;
    this.$nextTick(() => {
      (this.$refs.qrCodeUrl as HTMLFormElement).innerHTML = "";
      this.createQrCode(process.env.VUE_APP_FILE_QRCODE_ADDRESS + data.id);
    });
  }

  createQrCode(data: any) {
    var qrcode = new QRCode(this.$refs.qrCodeUrl, {
      text: data,
      width: 200,
      height: 200,
      colorDark: "#000000",
      colorLight: "#ffffff",
      correctLevel: QRCode.CorrectLevel.H,
    });
  }

  //行程录入提交
  saveSchedule(formName: string) {
    (this.$refs[formName] as HTMLFormElement).validate((valid: any) => {
      if (valid) {
        this.addFormData.speechTime = filters.dateFormat(
          this.addFormData.speechTime
        );
        this.addFormData.startDate = filters.dateFormat(
          this.addFormData.speechTime
        );
        this.addFormData.regulation = this.content;
        scheduleInsert(this.addFormData)
          .then((res) => {
            const { success, data, messgae } = res;
            if (success) {
              this.jobNeedShow = true;
              this.$message({
                type: "success",
                message: "保存成功",
                customClass: "message-override",
              });
              this.currentScheduleId = data;
              this.addDialogVisible = false;
              this.editJobDialogVisible = true;
              this.editJobFormData = new editJobFormData();
              this.getList();
              this.getJobListByid(this.currentScheduleId);
            } else {
              this.$message({
                type: "error",
                message: "保存失败",
              });
            }
          })
          .finally(() => {
            this.adddialogloading = false;
          });
      } else {
        return false;
      }
    });
  }

  // 根据itineraryId获取当前行程下的岗位列表
  getJobListByid(id: any) {
    let param = { itineraryId: id };
    getScheduleJobList(param).then((res) => {
      const { success, data, messgae } = res;
      if (success) {
        this.jobArr = data;
      } else {
        this.$message({
          type: "error",
          message: messgae,
        });
      }
    });
  }

  //点击编辑行程显示详情
  editSchedule(data: any) {
    this.editDialogVisible = true;
    this.editFormData.university = data.university;
    this.editFormData.speechTime = new Date(data.speechTime);
    this.editFormData.place = data.place;
    this.editFormData.address = data.address;
    this.editFormData.regulation = data.regulation;
    this.editFormData.id = data.id;
    this.editFormData.expectationNumber = data.expectationNumber;
  }
  //点击编辑岗位按钮
  editJob(data: any) {
    this.currentScheduleId = data.id;
    this.currentJobId = "";
    this.clickNo = null;
    this.editJobFormData = new editJobFormData();
    this.editJobDialogVisible = true;
    this.getJobListByid(data.id);
  }
  //编辑-岗位录入
  createJob(formName: string) {
    (this.$refs[formName] as HTMLFormElement).validate((valid: any) => {
      if (valid) {
        this.editJobDialogloading = true;
        this.editJobFormData.itineraryId = this.currentScheduleId;
        jobListInsert(this.editJobFormData)
          .then((res) => {
            const { success, data, messgae } = res;
            if (success) {
              this.jobNeedShow = true;
              this.$message({
                type: "success",
                message: "添加成功",
              });
              this.editJobFormData = new editJobFormData();
              this.getJobListByid(this.currentScheduleId);
            } else {
              this.$message({
                type: "error",
                message: messgae,
              });
            }
          })
          .finally(() => {
            this.editJobDialogloading = false;
          });
      } else {
        return false;
      }
    });
  }
  //点击岗位需求中的某个岗位获取岗位详情
  gojobDetail(jobId: any, index: any) {
    this.currentJobId = jobId;
    this.clickNo = index;
    let param = { jobId: jobId };
    getJobDetail(param)
      .then((res) => {
        const { success, data, messgae } = res;
        if (success) {
          this.editJobFormData.jobName = data.jobName;
          this.editJobFormData.jobDescription = data.jobDescription;
          this.editJobFormData.jobRequirements = data.jobRequirements;
          this.editJobFormData.number = data.number;
          this.editJobFormData.workPlace = data.workPlace;
          this.editJobFormData.education = data.education;
        } else {
          this.$message({
            type: "error",
            message: messgae,
          });
        }
      })
      .finally(() => {});
  }
  //编辑-新建
  newJob() {
    this.currentJobId = "";
    this.clickNo = null;
    this.editJobFormData = new editJobFormData();
  }
  //删除某个岗位
  deleteJob() {
    let param = { id: this.currentJobId };
    jobDelete(param)
      .then((res) => {
        const { success, data, messgae } = res;
        if (success) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.currentJobId = "";
          this.clickNo = null;
          this.getJobListByid(this.currentScheduleId);
          this.editJobFormData = new editJobFormData();
        } else {
          this.$message({
            type: "error",
            message: messgae,
          });
        }
      })
      .finally(() => {});
  }
  //编辑行程提交
  editScheduleSave(formName: any) {
    (this.$refs[formName] as HTMLFormElement).validate((valid: any) => {
      if (valid) {
        this.editdialogloading = true;
        if (typeof this.editFormData.speechTime != "string") {
          this.editFormData.speechTime = filters.dateFormat(
            this.editFormData.speechTime
          );
          this.editFormData.startDate = filters.dateFormat(
            this.editFormData.speechTime
          );
        } else {
          this.editFormData.startDate = this.editFormData.speechTime;
        }
        scheduleEdit(this.editFormData)
          .then((res) => {
            const { success, data, messgae } = res;
            if (success) {
              this.jobNeedShow = true;
              this.$message({
                type: "success",
                message: "保存成功",
              });
              this.editDialogVisible = false;
            } else {
              this.$message({
                type: "error",
                message: "保存失败",
              });
            }
          })
          .finally(() => {
            this.editdialogloading = false;
          });
      }
    });
  }
  //编辑 - 岗位-提交
  submitJob(formName: string) {
    (this.$refs[formName] as HTMLFormElement).validate((valid: any) => {
      if (valid) {
        this.editJobDialogloading = true;
        this.editJobFormData.itineraryId = this.currentScheduleId;
        this.editJobFormData.id = this.currentJobId;
        jobEdit(this.editJobFormData)
          .then((res) => {
            const { success, data, messgae } = res;
            if (success) {
              this.jobNeedShow = true;
              this.$message({
                type: "success",
                message: "保存成功",
              });
              this.currentJobId = "";
              this.clickNo = null;
              this.getJobListByid(this.currentScheduleId);
              this.editJobFormData = new editJobFormData();
            } else {
              this.$message({
                type: "error",
                message: messgae,
              });
            }
          })
          .finally(() => {
            this.editJobDialogloading = false;
          });
      } else {
        return false;
      }
    });
  }

  //获取岗位需求列表
  JobList() {
    this.divJobLoading = true;
    getJobList({})
      .then((res) => {
        const { success, data, messgae } = res;
        if (success) {
          this.cityOptions = [];
          for (let item of data) {
            this.cityOptions.push(item.jobName);
            this.cityOptionsList.push({
              itineraryId: item.id,
              jobName: item.jobName,
            });
          }
        } else {
          this.$message({
            type: "error",
            message: messgae,
          });
        }
      })
      .finally(() => {
        this.divJobLoading = false;
      });
  }

  // 删除行程
  remove(data: any) {
    let param = { id: data.id };
    this.$confirm("是否删除?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        this.isRequest = true;
        scheduleDelete(param)
          .then((res) => {
            const { data, success, message } = res;
            if (success) {
              this.$message({
                type: "success",
                message: "删除成功",
              });
              this.getList();
            } else {
              this.$message({
                type: "error",
                message: "删除失败",
              });
            }
          })
          .finally(() => {
            this.isRequest = false;
          });
      })
      .catch(() => {});
  }
  // 结束行程
  finish(data: any) {
    if (data.stateStr == "未发布") {
      this.$message({
        type: "error",
        message: "未发布的行程无法结束",
      });
    } else {
      let param = { id: data.id };
      this.$confirm("是否确认结束?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.isRequest = true;
          scheduleFinish(param)
            .then((res) => {
              const { data, success, message } = res;
              if (success) {
                this.$message({
                  type: "success",
                  message: "行程已结束",
                });
                this.getList();
              } else {
                this.$message({
                  type: "error",
                  message: "结束行程失败",
                });
              }
            })
            .finally(() => {
              this.isRequest = false;
            });
        })
        .catch(() => {});
    }
  }
  // 跳转新建页面
  addFrom() {
    this.addDialogVisible = true;
    this.jobNeedShow = false;
    this.addFormData = new addFormData();
    this.JobList();
    this.addCheckedCities = [];
    this.$nextTick(() => {
      addQuillTitle();
    });
  }

  changePage(index: number) {
    this.req.pageNo = index;
    this.getList();
  }
  /* **************************************** */
  //岗位录入提交
  saveJob() {
    this.addJobDialogloading = true;
    this.addJobFormData.itineraryId = this.currentScheduleId;
    jobListInsert(this.addJobFormData)
      .then((res) => {
        const { success, data, messgae } = res;
        if (success) {
          this.jobNeedShow = true;
          this.$message({
            type: "success",
            message: "添加成功",
          });
          this.addJobDialogVisible = false;
        } else {
          this.$message({
            type: "error",
            message: messgae,
          });
        }
      })
      .finally(() => {
        this.addJobDialogloading = false;
      });
  }

  //行程录入岗位提交
  saveJobList(formName: any) {
    this.adddialogloading = true;
    (this.$refs[formName] as HTMLFormElement).validate((valid: any) => {
      if (valid) {
        this.addFormData.speechTime = filters.dateFormat(
          this.addFormData.speechTime
        );
        this.addFormData.startDate = filters.dateFormat(
          this.addFormData.speechTime
        );
        this.addFormData.regulation = this.content;
        scheduleInsert(this.addFormData)
          .then((res) => {
            const { success, data, messgae } = res;
            if (success) {
              this.jobNeedShow = true;
              this.currentScheduleId = data;
              let param: any = [];
              for (let item of this.addCheckedCities) {
                param.push({
                  itineraryId: this.currentScheduleId,
                  jobName: item,
                });
              }
              this.adddialogloading = false;
              this.addDialogVisible = false;
              this.addJobDialogVisible = true;

              this.getList();
              /*     jobListInsert(param)
                .then((res) => {
                  const { success, data, messgae } = res;
                  if (success) {
                    this.jobNeedShow = true;
                    this.$message({
                      type: "success",
                      message: "保存成功",
                    });
                    this.addDialogVisible = false;
                  } else {
                    this.$message({
                      type: "error",
                      message: messgae,
                    });
                  }
               
                })
                .finally(() => {
                  this.adddialogloading = false;
                }); */
            }
          })
          .finally(() => {});
      } else {
        return false;
      }
    });
  }
  jobListEdit() {
    let param = [];
    for (let item of this.editCheckedCities) {
      param.push({ itineraryId: this.editFormData.id, jobName: item });
    }
    jobEdit(param)
      .then((res) => {
        const { success, data, messgae } = res;
        if (success) {
          this.jobNeedShow = true;
          this.$message({
            type: "success",
            message: "提交成功",
          });
          this.editDialogVisible = false;
          this.getList();
        } else {
          this.$message({
            type: "error",
            message: messgae,
          });
        }
      })
      .finally(() => {
        this.editdialogloading = false;
      });
  }
  /* **************************************** */
}
